import i18n from '@/i18n'
import FormValidationRules from '@/components/shared/forms/FormValidationRules'

export const EmailAddressField = {
  type: 'v-text-field',
  model: 'emailAddress',
  props: {
    id: 'account-email-address',
    label: i18n.t('wallet.form.email-address.label'),
    outlined: true,
    'validate-on-blur': true,
    rules: [
      FormValidationRules.required(
        i18n.t('wallet.form.email-address.required')
      ),
      FormValidationRules.email(i18n.t('wallet.form.email-address.required'))
    ]
  }
}
